import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { cancel_run_executions_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AUTOMATION_RUNS_KEY, PROJECT_RUNS_KEY } from '@/utils/queryKeys.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { notifications } from '@mantine/notifications';
import { SimpleResponse } from '@/types/common.ts';

type props = {
  run_id: string;
};

const useCancelRunExecutions = (
  options: UseMutationOptions<SimpleResponse, AxiosError, props>,
): UseMutationResult<SimpleResponse, AxiosError, props> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ run_id }: props) => {
      const response = await apiClient.put(cancel_run_executions_url(run_id));

      notifications.show({ message: 'Run successfully canceled', color: 'blue' });

      await queryClient.invalidateQueries({ queryKey: AUTOMATION_RUNS_KEY(automationId) });
      await queryClient.invalidateQueries({ queryKey: PROJECT_RUNS_KEY });

      return response.data;
    },
    ...options,
  });
};

export default useCancelRunExecutions;
